import { TDataLayer } from "@porsche-customer/porschedatalayer-events/projects/navi/all/types";
import { Component, Element, h, Host, JSX, Prop } from "@stencil/core";
import { isString } from "@phn/utility/helper";
import { sendDataLayerEvent } from "@phn/services/analytics/data-layer-event-sender";
import {
  ClickElementType,
  ClickElementTypes,
  EventAction,
  EventActions,
} from "@phn/utility/constants/analytics";
import { RoutingKeys } from "@phn/entities/routing-key";
import MenuItemText from "./menu-item-text";
import Icon from "./menu-item-icon";

@Component({
  tag: "phn-nd-menu-item",
  styleUrl: "menu-item.scss",
  scoped: true,
})
export class MenuItem {
  @Prop() text = "";

  @Prop() analyticsId!: string;

  @Prop() subtext = "";

  @Prop() fontWeight = "regular";

  @Prop() elementId = "";

  @Prop() size = "inherit";

  @Prop() iconLeft = "";

  @Prop() iconRight = "";

  @Prop() link = "";

  @Prop() isLoading = false;

  @Prop() datalayerEventAction: EventAction = EventActions.NAVIGATION_CLICK;

  @Prop() customDatalayerProperties: TDataLayer = {};

  @Prop() target = "_self";

  @Prop() variant = "";

  @Prop() isModels = false;

  @Element() el!: HTMLPhnNdMenuItemElement;

  private sendDataLayerEvent(
    clickElementType: ClickElementType,
    elementId: string,
  ): void {
    sendDataLayerEvent({
      analyticsId: this.analyticsId,
      text: this.text,
      elementId,
      clickElementType,
      link: this.link,
      customDatalayerProperties: this.customDatalayerProperties,
      datalayerEventAction: this.datalayerEventAction,
    });
  }

  private existsSlot(slotName: string): boolean {
    return this.el.querySelector(`[slot="${slotName}"]`) !== null;
  }

  render(): JSX.Element {
    const isAccount = this.elementId
      ? this.elementId === RoutingKeys.ACCOUNT
      : this.analyticsId === "mainmenu.account";

    const body = (
      <div class="phn-flex-row phn-align-center">
        {this.existsSlot("media") ? (
          <div class="media-container skeleton-item">
            <slot name="media" />
          </div>
        ) : null}
        <Icon isLoading={this.isLoading} icon={this.iconLeft} />
        {isAccount ? (
          <phn-p-icon
            name="user"
            size="medium"
            role="presentation"
          ></phn-p-icon>
        ) : null}
        {!this.isModels && isString(this.text) ? (
          <MenuItemText
            size={
              isAccount ||
              this.elementId?.startsWith(`${RoutingKeys.ELECTRIC_OWNERSHIP}/`)
                ? "medium"
                : this.size
            }
            text={this.text}
            subtext={this.subtext}
            fontWeight={this.fontWeight}
          />
        ) : undefined}
        {this.existsSlot("suffix") ? (
          <div>
            <slot name="suffix" />
          </div>
        ) : null}
      </div>
    );

    return (
      <Host class={`${this.variant} ${isAccount ? "account" : ""}`}>
        {this.existsSlot("model-area") ? (
          <div class="model-container skeleton-item">
            <slot name="model-area" />
          </div>
        ) : isString(this.link) && isString(this.text) ? (
          <a
            class={`pure-link ${isString(this.iconLeft) ? "has-icon" : ""} ${
              this.elementId.includes("loginUser") ? "fs-mask" : ""
            }`}
            data-cs-mask={this.elementId.includes("loginUser")}
            data-id={this.elementId}
            onClick={() => {
              this.sendDataLayerEvent(ClickElementTypes.Link, this.elementId);
            }}
            href={this.link}
          >
            {body}
          </a>
        ) : (
          <phn-p-button-pure
            class={`${isString(this.iconLeft) ? "has-icon" : ""} ${
              this.elementId.includes("loginUser") ? "fs-mask" : ""
            }`}
            size="inherit"
            data-cs-mask={this.elementId.includes("loginUser")}
            icon={isString(this.iconRight) ? this.iconRight : "none"}
            align-label="start"
            stretch={isString(this.iconRight) ? "true" : "false"}
            data-id={this.elementId}
            onClick={() => {
              this.sendDataLayerEvent(ClickElementTypes.Button, this.elementId);
            }}
          >
            {body}
          </phn-p-button-pure>
        )}
      </Host>
    );
  }
}
